__turbopack_context__.v({
  "expandLink": "_34SA6q_expandLink",
  "explainAnchor": "_34SA6q_explainAnchor",
  "explainContent": "_34SA6q_explainContent",
  "explainer": "_34SA6q_explainer",
  "formattedDate": "_34SA6q_formattedDate",
  "helpLink": "_34SA6q_helpLink",
  "jsonLink": "_34SA6q_jsonLink",
  "nullValue": "_34SA6q_nullValue",
  "rssLink": "_34SA6q_rssLink",
  "showAll": "_34SA6q_showAll",
  "smallExternalIcon": "_34SA6q_smallExternalIcon",
  "spacer": "_34SA6q_spacer",
  "spinner": "_34SA6q_spinner",
  "stickyChild": "_34SA6q_stickyChild",
  "stickyParent": "_34SA6q_stickyParent",
  "summary": "_34SA6q_summary",
  "tooltipCode": "_34SA6q_tooltipCode",
});
